import { DataStorage } from '@studyportals/data-storage';
import { UtmInfo } from './UtmInfo';
import { UtmFields } from './UtmFields';

const TTL = 259200;

class UtmInfoStorage {
	private readonly UtmAllowedKeys = [
		UtmFields.UTM_MEDIUM.valueOf(),
		UtmFields.UTM_SOURCE.valueOf(),
		UtmFields.UTM_CAMPAIGN.valueOf(),
		UtmFields.UTM_CONTENT.valueOf(),
		UtmFields.UTM_TERM.valueOf()
	];

	constructor() {
		this.storeUtmInformation();
	}

	private storeUtmInformation(): void {
		const queryParameters = new URLSearchParams(window.location.search.substring(1));

		const utmParametersObject = this.getUTMQueryParams(queryParameters.entries());
		if (!this.shouldSetUtmInformation(utmParametersObject)) {
			return;
		}

		DataStorage.store('utmInfo', JSON.stringify(utmParametersObject), TTL);
	}

	private getUTMQueryParams(entries: IterableIterator<[string, string]>): UtmInfo {
		const result: UtmInfo = {};

		for (const [key, value] of entries) {
			if (this.shouldBeInUtmObject(key, value)) {
				result[key as keyof UtmInfo] = value;
			}
		}
		return result;
	}

	private shouldBeInUtmObject(key: string, value: string): boolean {
		return this.UtmAllowedKeys.includes(key.toLocaleLowerCase()) && value !== '';
	}

	private shouldSetUtmInformation(utmInfoObject: UtmInfo): boolean {
		return Object.keys(utmInfoObject).length > 0;
	}
}

new UtmInfoStorage();
